import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

export default function GroupCompletionLinearFill({
    calendarDataKey,
    eventData
}) {

    const groupAthletes = useSelector((state) => state.athleteProfile.groupAthletes)
    const groupIndividualCompletionData = useSelector((state) => state.athleteProfile.groupIndividualCompletionData)

    const [calendarItemGroupCompletionData, setCalendarItemGroupCompletionData] = useState(null)
    const [completionCount, setCompletionCount] = useState(null)

    const InitializeCalendarItemGroupCompletionData = () => {

        // console.log('InitializeCalendarItemGroupCompletionData')

        // console.log(groupIndividualCompletionData)

        // Filter completion data to current week

        var tempCalendarItemGroupCompletionData = []

        for (const completionData of groupIndividualCompletionData) {

            if (completionData.weekOfTheYearKey === eventData.extendedProps.weekOfTheYearKey) {
                tempCalendarItemGroupCompletionData.push(completionData)
            }

        }

        // console.log(tempCalendarItemGroupCompletionData)

        // Count number of completions

        const workoutTemplateKeysToCompletedColumnNames = {
            'strength-session-a': 'strengthSessionACompletionDataJSON',
            'strength-session-b': 'strengthSessionBCompletionDataJSON',
            'mobility-a': 'mobilityACompletionDataJSON',
            'mobility-b': 'mobilityBCompletionDataJSON'
        }

       var completionCount = 0

        for (const completionData of tempCalendarItemGroupCompletionData) {

            // console.log(completionData)

            const columnName = workoutTemplateKeysToCompletedColumnNames[eventData.extendedProps.workoutTemplateKey]

            // console.log(columnName)

            if (completionData[columnName].completed) {
                completionCount = completionCount + 1
            }

        }

        setCalendarItemGroupCompletionData(tempCalendarItemGroupCompletionData)
        setCompletionCount(completionCount)

    }

    useEffect(() => {
        if (calendarDataKey === 'past' && calendarItemGroupCompletionData === null) {
            InitializeCalendarItemGroupCompletionData()
        }
    }, [])

    if (groupAthletes.length === 0) {
        return (
            <div className='pt-0.5'>
                <div className='p-1 relative'>
                    <div className='h-4 w-full bg-white rounded-full border border-gray-400 relative overflow-hidden p-[1px]' />
                        
                    <p className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-600 text-xxs'>
                        No Athletes
                    </p>
                </div>
            </div>
        )
    }

    if (calendarDataKey === 'past') {
        return (
            <div className='pt-0.5'>
                {calendarItemGroupCompletionData === null && (
                    <div className='p-1 relative'>
                        <div className='h-4 w-full bg-gray-200 rounded-full animate-pulse' />

                    </div>
                )}

                {calendarItemGroupCompletionData !== null && (
                    <div className='p-1 relative'>
                        <div className='h-4 w-full bg-white rounded-full border border-gray-400 relative overflow-hidden p-[1px]'>
                            <div
                                className='h-full bg-orange-300 rounded-full'
                                style={{
                                    width: `${
                                        calendarItemGroupCompletionData.length
                                            ? (completionCount / calendarItemGroupCompletionData.length) * 100
                                            : 0
                                    }%`
                                }}
                            />
                        </div>

                        <p className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-600 text-xxs font-bold'>
                            {completionCount}/{calendarItemGroupCompletionData.length}
                        </p>
                    </div>
                )}
            </div>
        )
    }

    if (calendarDataKey === 'future') {
        return (
            <div className='pt-0.5'>
                <div className='p-1 relative'>
                    <div className='h-4 w-full bg-white rounded-full border border-gray-400 relative overflow-hidden p-[1px]' />
                        
                    <p className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-600 text-xxs font-bold'>
                        0/{groupAthletes.length}
                    </p>
                </div>
            </div>
        )
    }
}